import script from "./HelpSidebarEn.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpSidebarEn.vue?vue&type=script&setup=true&lang=js"

import "./HelpSidebarEn.vue?vue&type=style&index=0&id=f822a0aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f822a0aa"]])

export default __exports__